import { createTheme } from "@mui/material/styles";
import { deDE as coreDeDE } from "@mui/material/locale";
import { deDE } from "@mui/x-data-grid-pro/locales";

const theme = createTheme(
  {
    palette: {
      primary: {
        main: "#3E5AA3",
      },
      secondary: {
        main: "#f8f8f8",
      },
      background: { default: "#f8f8f8" },
    },
    typography: {
      fontFamily: "Nunito, Arial",
    },
  },
  deDE,
  coreDeDE
);

export default theme;
